import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import SwaggerPage from './SwaggerPage';
import { RootState } from '../../redux/store';
import { useSelector } from 'react-redux';
import colorConfigs from '../../configs/colorConfigs';

const APIPage = () => {
  const authData = useSelector((state: RootState) => state.auth);

  return authData.isPortalUser ? (
    <Box data-testid="Box-klzs" sx={{ p: { xs: 1, md: 1.5 }, height: '100dvh', minHeight: 360, boxSizing: 'border-box', overflow: 'auto' }}>
      <Typography
        data-testid="Typography-usiu"
        component="h1"
        align="center"
        fontWeight={700}
        fontSize={28}
        color={colorConfigs.tables.headBg}
        sx={{ pt: 1.5, mb: '-5px', px: 7 }}
      >
        API Documentation
      </Typography>
      <Box
        data-testid="Box-k0n2"
        sx={{ display: 'flex', flexDirection: 'column' }}
      >
        <SwaggerPage />
      </Box>
    </Box>
  ) : null;
};

export default APIPage;
